import { render } from "./BeetseedIcon.vue?vue&type=template&id=cca476d6&scoped=true"
import script from "./BeetseedIcon.vue?vue&type=script&lang=js"
export * from "./BeetseedIcon.vue?vue&type=script&lang=js"

import "./BeetseedIcon.vue?vue&type=style&index=0&id=cca476d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca476d6"]])

export default __exports__